import React from "react";
import { useDrop } from 'react-dnd';
import { Grid, Card } from "@mui/material";
import Typography from '../../../commonComponents/Typography';
import placeholder from '../../../../assets/images/comparison-placeholder.png';

export interface ITargetBoxProps {
  optionNumber?: any,
  locale?: any,
};

export const TargetBox: React.FC<ITargetBoxProps> = (props): JSX.Element => {
  const {optionNumber, locale} = props;
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: 'box',
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }))
  const isActive = canDrop && isOver
  let border = '1px solid #e5e6ec';
  if (isActive) {
    border = '2px dashed #2196f3';
  } else if (canDrop) {
    border = '1px solid #e5e6ec';
  }
  return (
    <Card id='crd-targetbox-container' ref={drop} className="comparison-card-container" style={{ border, flex: 1 }}>
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <Typography style={{ textAlign: 'center', marginTop: '2rem', fontSize: '18px' }} as={'h3'}>
          {locale?.selectDeviceComponent?.comparisonHeader_1} {optionNumber}
        </Typography>
        <img src={placeholder} alt='device comparison' title='device comparison' className="placeholder" />
        <Typography style={{ textAlign: 'center' }}>
          {locale?.selectDeviceComponent?.comparisonHeader_2}<br />
          {locale?.selectDeviceComponent?.comparisonHeader_3}
        </Typography>
      </Grid>
    </Card>
  )
}
